
class FetchUserListingsCommand {
	static protocol = {}

	constructor() {}
}

export default FetchUserListingsCommand